<template>
  <VincCalculatingExportPdf />
</template>

<script>
import VincCalculatingExportPdf from "@/components/Calculatings/VincCalculating/ExportPdf.vue";
export default {
  components: { VincCalculatingExportPdf },
};
</script>

<style></style>
